import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185f1ce8"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "text-center pt-3 mt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/images/back-1.svg" }, null, -1))
const _hoisted_4 = { class: "text-center pt-3 mt-3" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "mb-6 mt-10"
}
const _hoisted_7 = { class: "d-flex justify-content-center text-center" }
const _hoisted_8 = { class: "d-flex justify-content-center align-items-center gap-4" }
const _hoisted_9 = { class: "label required mb-1" }
const _hoisted_10 = { class: "fv-plugins-message-container mt-2" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "d-flex justify-content-center mt-6" }

import { ref, inject } from "vue";
import { isMobile } from "@/core/config/WindowConfig";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import { Field } from "vee-validate";

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectTenantPage',
  setup(__props) {

const showPage = inject<any>("showPage");
const isSubmitting = inject<any>("isSubmitting");
const tenantsOptions = inject<any>("tenantsOptions");
const selectedTenant = inject<any>("selectedTenant");
const twoFaRequired = inject<any>("twoFaRequired");
const twoFaCode = inject<any>("twoFaCode");

const onSubmitLogin = inject<any>("onSubmitLogin");

const flagList = ref({
  1: "/images/flags/au.svg",
  10000: "/images/flags/earth.svg",
  10002: "/images/flags/mn.svg",
  10004: "/images/flags/vn.svg",
  10005: "/images/flags/jp.svg",
});

const getFlagSrc = (id) => {
  return flagList.value[id] || "/images/flags/default.svg"; // Provide a default flag if id not found
};

const loginWithTenantId = async (tenantId: number) => {
  selectedTenant.value = tenantId;
  await onSubmitLogin();
};

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["d-flex justify-content-center flex-wrap", _unref(isMobile) ? 'gap-4' : 'gap-12'])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tenantsOptions), (item, index) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          class: _normalizeClass(["w-150px cursor", _unref(isMobile) ? 'my-3' : '']),
          "body-style": { padding: '40px' },
          key: index,
          onClick: ($event: any) => (loginWithTenantId(item))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: getFlagSrc(item),
              alt: "",
              class: "img-rounded"
            }, null, 8, _hoisted_1),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("title.tenants." + item)), 1)
            ])
          ]),
          _: 2
        }, 1032, ["class", "onClick"]))
      }), 128)),
      _createVNode(_component_el_card, {
        class: "w-150px cursor",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showPage.value = 'LoginPage')),
        "body-style": { padding: '40px' }
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("action.back")), 1)
          ])
        ]),
        _: 1
      })
    ], 2)), [
      [_directive_loading, _unref(isSubmitting)]
    ]),
    (_unref(twoFaRequired))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("fields.twoFactorAuthentication")), 1),
                _createVNode(_unref(Field), {
                  tabindex: "2",
                  modelValue: _unref(twoFaCode),
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(twoFaCode) ? (twoFaCode).value = $event : null)),
                  class: "form-control form-control-lg form-control-solid w-200px",
                  type: "text",
                  name: "twoFaCode",
                  autocomplete: "off"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(twoFaCode),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(twoFaCode) ? (twoFaCode).value = $event : null)),
                      class: "w-200px",
                      name: "twoFaCode",
                      placeholder: _ctx.$t('tip.pleaseInput'),
                      size: "large",
                      tabindex: "2",
                      type: "text"
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("fields.pleaseEnterTwoFactorCode")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(LoadingButton, {
                "is-loading": _unref(isSubmitting),
                "save-title": _ctx.$t('action.login'),
                class: "btn btn-lg w-200px loginBtn",
                onClick: _withModifiers(_unref(onSubmitLogin), ["prevent"])
              }, null, 8, ["is-loading", "save-title", "onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})